import { http } from '../../config/axios'

export default function putPlano(plano: any): Promise<string> {
  return http
    .put('api/plano', plano)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put plano', error)
      throw Error(error.response.data)
    })
}
